import React from 'react'
import phoneCoBee from '_images/landing-phone-original.png'

const StorySection = () => (
  <section className='story-section' id='story'>
    <div className='landing-shell story-section__grid'>
      <div className='story-card landing-reveal'>
        <div className='story-card__badge'>🐝 Where it began</div>
        <div className='story-card__row'>
          <div className='story-card__phone'>
            <img src={phoneCoBee} alt='Co-bee mobile app preview' />
          </div>
          <div className='story-card__caption'>
            <div className='story-card__year'>2020</div>
            <div className='story-card__quote-mark'>&quot;</div>
            <blockquote className='story-card__quote'>
              Chats. Spreadsheets. Chaos. There had to be a better way.
            </blockquote>
            <div className='story-card__author'>The Co-bee founding team</div>
          </div>
        </div>
      </div>

      <div className='story-section__content'>
        <p className='section-label'>Our origin</p>
        <h2 className='section-title section-title--dark'>
          Born from a <em>real</em> problem
        </h2>
        <p>
          Co-bee was born during the COVID-19 pandemic, when we saw how hard it was for community
          hosts to run group-buy with limited tools.
        </p>
        <p>
          As orders grew, hosts were juggling payments, deliveries, and product lists across chats
          and spreadsheets. It was stressful, time-consuming, and far from ideal.
        </p>
        <p>
          So we built Co-bee. What started as a simple solution to help friends quickly became a
          platform that brings people together, makes group-buy effortless, and helps communities
          grow stronger together.
        </p>
      </div>
    </div>
  </section>
)

export default StorySection
